export const ServiceEnum = Object.freeze({
    OTP_RegAccount : 1000,	//OTP đăng ký TK
    OTP_AuthenAccount : 1001,	//OTP đăng nhập TK
    OTP_Changepass : 1002,	//OTP Đổi mật khẩu
    OTP_ResetPass : 1003,	//OTP Quên mật khẩu
    OTP_ChangeEmail : 1004,	//OTP Thay đổi Email
    OTP_ChangeMobile : 1005,	//OTP Thay đổi SĐT
    OTP_DelOTPSMS : 1006,	//OTP Huy DV bao mat SMS
    OTP_DelOTPEmail : 1008,	//OTP Huy DV bao mat Email
    OTP_RegOTPApp : 1009,	//Đăng ký sử dụng OTP App
    OTP_DeviceSecure : 1010,	//OTP Bảo mật thiết bị
    OTP_RegOTPSMS : 1011,	//Đăng ký sử dụng OTP SMS
    OTP_RegOTPEmail : 1012,	//Đăng ký sử dụng OTP Email
    OTP_ResetPassByEmail : 1013,    //OTP Email Quên mật khẩu
    OTP_RegOTPVoice : 1014,    //OTP đăng ký Voice
    OTP_LoginByOTP : 1015,    //OTP Đăng nhập bằng OTP
  });